
import React, { useState, useEffect, Suspense, useCallback, lazy } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  ButtonGroup,
  Dropdown,
  Modal,
  Form,
  Table,
  Nav,
  Tab,
  Tabs,
  Card,
  Breadcrumb,
  DropdownButton,
  Badge,
  Spinner,
  InputGroup,
} from "react-bootstrap";
import TextField from '@mui/material/TextField';
import { Link } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import Autocomplete from '@mui/material/Autocomplete';
import './ProjectView.css';
import Popup from 'reactjs-popup';
// import 'reactjs-popup/dist/index.css';
import "bootstrap-icons/font/bootstrap-icons.css";
import * as Icon from 'react-bootstrap-icons';
// import { threeDotsVertical } from 'react-bootstrap-icons';
import { useSelector, useDispatch } from "react-redux";
import { fetchRoomList, updateRoomOrder } from "../redux/viewRoomReducer";
import { fetchQuotationList } from "../redux/quotationReducer";
// import ClientPDF from "./ClientPDF";
// import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import { Triangle } from 'react-loader-spinner';
// import { renameRoomName } from "../redux/renameRoomReducer";
import ExportToExcel from "./ExportToExcel";
import { auth, firestore as db } from "../config/Config";
import { renameDesignName } from "../redux/renameDesignReducer";
import { duplicateDesigns } from "../redux/duplicationDesignReducer";
import ViewProfile from "./ViewProfile";
import ExportExcel from "./ExportExcel";
import axios from "axios";
import Sidebar from "./SidebarNav";
// import { asString } from "html2canvas/dist/types/css/types/color";

import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import Paper from '@mui/material/Paper';
import { fetchProjectList } from "../redux/projectReducer";
import Swal from "sweetalert2";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { updateQuotationPermission } from "../redux/QuotationPermission";
import { fetchAllAssignedRooms } from "../redux/AssigneProject-redux/AssignedProjectViewReducer";





function ProjectView() {

  const [currentPage, setCurrentPage] = useState(1);
  const [lim, setLim] = useState(10);


  const userDetailsLocal = localStorage.getItem('userDetails');
  const userDetailsLo = JSON.parse(userDetailsLocal);
  console.log("userDetailsLo", userDetailsLo);


  const location = useLocation();
  const [dataOfClient, setDataOfClient] = useState(location.state);

  // console.log('dataof page viw', location);
  console.log('dataof client', dataOfClient);
  const [SelectedPrice, setSelectedPrice] = useState(dataOfClient.priceType);

  const [userList, setUserList] = useState([]);
  console.log("userList", userList);

  const [userdata, setUserdata] = useState({});

  // fetchUserData
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(`https://us-central1-fabdiz-quote.cloudfunctions.net/api/client/${dataOfClient.id}`);
        const data = await response.json();
        setUserdata(data);


      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    fetchUserData();
  }, [dataOfClient.id, SelectedPrice]);

  console.log("userdata", userdata);

  // to fetch the designers list 
  const fetchUsers = async () => {
    try {
      const response = await fetch('https://us-central1-fabdiz-quote.cloudfunctions.net/api/users');
      const data = await response.json();
      console.log("Fetched data:", data); // Log the full response to check its structure

      // Add this check to see if users are directly in data or under a different key
      if (!data || !Array.isArray(data)) {
        console.error("Data is not in the expected format:", data);
        return;
      }

      // Assuming the data is an array of users
      const formattedUsers = data.map(user => ({
        label: user.name,         // Make sure this matches the actual property name for user names
        userID: user.id,   // Make sure this matches the actual property name for user IDs
        userDesignation: user.designation,    // Make sure this matches the actual property name for user IDs
        userEmail: user.email    // Make sure this matches the actual property name for user IDs
      }));

      setUserList(formattedUsers); // Set the formatted data as options for Autocomplete
    } catch (error) {
      console.error('Error fetching user list:', error);
    }
  };

  const navigation = useNavigate();
  const dispatch = useDispatch();
  const { userData, userLoader, userError } = useSelector((state) => state.viewusers);

  // useEffect(() => {
  //   const clientUID = dataOfClient.id;
  //   console.log("checking ID", clientUID);
  //   dispatch(fetchQuotationList({ clientUID, page: currentPage, lim }));
  // }, [currentPage, lim, dispatch]);

  useEffect(() => {
    const clientUID = dataOfClient.id;
    // console.log("Fetching quotations for client ID:", clientUID);
    dispatch(fetchQuotationList({ clientUID, roomName: 'assignRoom', page: currentPage, lim }));
  }, [currentPage, lim, dispatch, dataOfClient.id]);

  // const { data, loader, error } = useSelector((state) => state.viewquotes);

  // console.log('Quotation data:', data);
  const { allAssigneRoomData, viewLoader, viewError } = useSelector((state) => state.assigneProjectRooms);
  const viewData = allAssigneRoomData;
  const { data, loader, error } = useSelector((state) => state.viewquotes);
  console.log(
    'Keys:',
    data.quotes
  );
  console.log(
    'viewData:',
    viewData
  );

  // const filteredQuotiationAssigned = data.quotes


  // console.log(dataOfClient);
  const result = Array.isArray(viewData.assignedRooms) ? viewData.assignedRooms.reduce((finalArray, current) => {
    // console.log('viewData f', finalArray);
    // console.log('viewData c', current);

    let obj = finalArray.find(item => item.roomTypeName === current.roomTypeName);
    // console.log('obj', obj);
    if (obj) {
      return finalArray;
    }
    return finalArray.concat([current]);
  }, []) : [];




  console.log(
    'viewData:',
    result
  );

  useEffect(() => {
    if (dataOfClient.id) {
      console.log("dataof client", dataOfClient.id);
      dispatch(fetchAllAssignedRooms(dataOfClient.id));
    }
  }, [dispatch, dataOfClient.id]);




  // console.log('data', data);


  const userUID = localStorage.getItem('userUID');
  // console.log("userUID", userUID);
  const priceState222 = useSelector((state) => state.price.value);

  const handleLogOut = () => {
    auth.signOut();
    window.location.reload();
  }


  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
      href=""
      ref={ref}
      onClick={e => {
        e.preventDefault();
        onClick(e);
      }}
    >
      {/* custom icon */}
      {children}

    </a>
  ));

  // To add rooms for 
  const addRoom = () => {
    dataOfClient['roomType'] = "";
    dataOfClient['roomName'] = "";
    navigation('/assignRoom/view-rooms/add-rooms', { state: dataOfClient })
  }

  // To add designs in same rooms
  const addDesign = (i) => {
    dataOfClient['roomType'] = i.roomType;
    dataOfClient['roomName'] = i.roomTypeName;
    dataOfClient['priceMode'] = i.priceMode;
    navigation('/assignRoom/view-rooms/add-rooms', { state: dataOfClient })
  }
  // To edit designs in same rooms
  const editDesign = (i) => {
    // dataOfClient['roomType'] = i.roomType;
    // console.log("edti before go", i);
    dataOfClient['editData'] = i;
    // console.log("dataOfClient",dataOfClient);

    navigation('/assignRoom/view-rooms/edit-rooms', { state: dataOfClient })
  }


  // To view designs in same rooms
  const viewDesign = (i) => {
    // dataOfClient['roomType'] = i.roomType;
    dataOfClient['viewData'] = i;
    navigation('/assignRoom/view-rooms/view-designs', { state: dataOfClient })
  }
  // rename modal
  const [renameOn, setRenameOn] = useState(false);
  const [renameID, setRenameID] = useState('');
  const [nameRoomTypeName, setNameRoomTypeName] = useState('');
  const [preNameRoomTypeName, setPreNameRoomTypeName] = useState('');
  //  const [renameRoomTypeName, setRenameRoomTypeName] = useState('');
  const [statuesOn, setStatuesOn] = useState(false);


  const handleRenameCloseOn = () => {
    setRenameOn(false);
  };

  const renameModal = (i) => {
    console.log("isathish", i);

    setNameRoomTypeName(i.roomTypeName);
    setPreNameRoomTypeName(i.roomTypeName);
    setRenameID(i.id);
    setRenameOn(true);

  };
  // to rename rooms name
  const handleRenameCom = async () => {
    const cid = dataOfClient.id;
    const id = renameID; // `id` is declared but not used; consider removing or using it as needed.

    console.log("cid", cid);
    console.log("preNameRoomTypeName", preNameRoomTypeName);
    console.log("nameRoomTypeName", nameRoomTypeName);
    console.log("id", id);

    try {
      const response = await axios.put('https://us-central1-fabdiz-quote.cloudfunctions.net/api/updateRoomName', {
        "cid": cid,
        "preRoomTypeName": preNameRoomTypeName,
        "roomTypeNewName": nameRoomTypeName,
        state: "AssignedRooms", //while creating assign room this shhould be dinamic
        "roomId": id
      });

      console.log(response.data.message);
      // Uncomment and use the following if you want to refresh the room list after renaming
      const viewData = {
        Id: dataOfClient.id,
      };

      dispatch(fetchAllAssignedRooms(dataOfClient.id));

    } catch (error) {
      console.log("Rename Room error", error.response ? error.response.data.message : 'Error updating room names');
    }

    setRenameOn(false); // This line is correctly placed and will toggle the renaming UI off.

    // Uncomment and use these lines if you want to dispatch actions after renaming
    // dispatch(renameRoomName(roomTypeNewName)); // Assuming you have this action set up to update the state
    // dispatch(fetchRoomList(viewData));
    // dispatch(fetchQuotationList(viewData));
    // dispatch(fetchProjectList());
  };


  // Design Rename Modal

  // rename modal
  const [renameDesignModal, setRenameDesignModal] = useState(false);
  const [renameDesignID, setRenameDesignID] = useState('');
  const [newDesignTypeName, setNewDesignTypeName] = useState('');
  //  const [preNameRoomTypeName, setPreNameRoomTypeName] = useState('');
  //  const [renameRoomTypeName, setRenameRoomTypeName] = useState('');
  const [selectedName, setSelectedName] = useState(null);
  console.log('selectedName', selectedName);


  const handleRenameDesignCloseModal = () => {
    setRenameDesignModal(false);
  };

  const renameDesignModalFun = (i) => {
    console.log("checking whole desig nData", i)
    // setNameRoomTypeName(i.roomTypeName);
    setNewDesignTypeName(i.roomTypeDesign);
    setRenameDesignID(i.id);
    setRenameDesignModal(true);

  };

  const handleRenameDesignModal = async () => {

    const cid = dataOfClient.id;
    const id = renameID; // `id` is declared but not used; consider removing or using it as needed.

    console.log("cid", cid);
    console.log("preNameRoomTID", renameDesignID);
    console.log("nameDesignTypeName", newDesignTypeName);

    try {
      const response = await axios.put('https://us-central1-fabdiz-quote.cloudfunctions.net/api/updateDesignName', {
        "cid": cid,
        "designId": renameDesignID,
        "roomDesignNewName": newDesignTypeName,
        state: 'AssignedRooms'
      });

      console.log(response.data.message);
      // Uncomment and use the following if you want to refresh the room list after renaming
      const viewData = {
        Id: dataOfClient.id,
      };

      dispatch(fetchAllAssignedRooms(dataOfClient.id));

    } catch (error) {
      console.log("Rename Room error", error.response ? error.response.data.message : 'Error updating room names');
    }

    // setRenameOn(false); // This line is correctly placed and will toggle the renaming UI off.

    //  const newRoomName = {
    //   cid : dataOfClient.ID,
    //   id: renameDesignID,
    //   roomTypeNewName: newDesignTypeName,
    //  }
    //  console.log("sanja",newRoomName);
    // dispatch(renameDesignName(newRoomName));
    // const viewData = {
    //   Id : dataOfClient.ID,
    // };
    // dispatch(fetchRoomList(viewData));
    // dispatch(fetchQuotationList(viewData));
    // dispatch(fetchRoomList(viewData));
    // dispatch(fetchProjectList());
    setRenameDesignModal(false);
  }

  const duplicationDesign = async (l) => {
    console.log('Duplicate:', l);
    console.log('Client ID:', dataOfClient.id);

    // Create a copy of the design data and update the design name
    const designData = {
      ...l,
      roomTypeDesign: `${l.roomTypeDesign} Copy`, // Append "Copy" to the design name
      ID: dataOfClient.id, // Pass the parent document ID
      state: 'AssignedRooms'
    };

    try {
      // Dispatch the duplicateDesigns action to create a duplicate in Firestore
      await dispatch(duplicateDesigns(designData)).unwrap();

      // Fetch the updated room list after duplication
      const viewData = { Id: dataOfClient.id };
      dispatch(fetchAllAssignedRooms(dataOfClient.id));
    } catch (error) {
      console.error('Error duplicating design:', error);
    }
  };

  const handleCardClick = (e) => {
    if (!e.target.closest(".dropdown-menu")) {
      // Check if the clicked element is not inside a dropdown-menu
      // redirectToEditPage();
    }
  };



  // Delete Method for Rooms 

  // const deleteRoomModal = async (roomName) => {
  //   // roomName.preventDefault();
  //   let clientId = dataOfClient.id;
  //   let roomTypeName = roomName.roomTypeName;
  //   // console.log("data", roomName);
  //   // console.log("data", dataOfClient);
  //   console.log("cliet", clientId);
  //   console.log("roomname", roomTypeName);
  //   // const querySnapshot = await db.collection("client").doc(dataOfClient.ID).collection("Rooms").where("roomTypeName", "==", roomName.roomTypeName).get();
  //   try {
  //     const response = await axios.delete(`https://us-central1-fabdiz-quote.cloudfunctions.net/api/deleteRoom/${clientId}/${roomTypeName}`);
  //     console.log("sder", response.data.message);
  //     const viewData = {
  //       Id: clientId,
  //     };

  //     dispatch(fetchRoomList(viewData));
  //     // setMessage(response.data.message);
  //   } catch (error) {
  //     console.log("Error Message to delete", error.response?.data?.message || 'An error occurred');
  //   }
  //   // dispatch(fetchRoomList(viewData));
  //   // dispatch(fetchQuotationList(viewData));
  //   // window.location.reload();
  // }

  const deleteRoomModal = async (roomName) => {
    const clientId = dataOfClient.id;
    const roomTypeName = encodeURIComponent(roomName.roomTypeName);

    const confirm = await Swal.fire({
      title: 'Are you sure?',
      text: `Do you want to delete the room "${roomName.roomTypeName}"? This action cannot be undone.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    });

    if (!confirm.isConfirmed) return;

    try {
      const url = `https://us-central1-fabdiz-quote.cloudfunctions.net/api/deleteAssignedRoom/${clientId}/${roomTypeName}`;
      const response = await axios.delete(url);

      Swal.fire({
        title: 'Deleted!',
        text: response.data.message || 'Room has been successfully deleted.',
        icon: 'success',
      });

      dispatch(fetchAllAssignedRooms(dataOfClient.id));
    } catch (error) {
      console.error("Error deleting room:", error);

      Swal.fire({
        title: 'Error!',
        text: error.response?.data?.message || 'Something went wrong while deleting the room.',
        icon: 'error',
      });
    }
  };





  // Delete Method for Design Options 

  const deleteDocument = async (id) => {

    const clientId = dataOfClient.id;
    const designId = id.id.trimEnd();

    const confirmation = await Swal.fire({
      title: 'Are you sure?',
      text: 'You are about to delete this design. This action cannot be undone!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    });

    if (confirmation.isConfirmed) {
      try {
        const response = await axios.delete(
          `https://us-central1-fabdiz-quote.cloudfunctions.net/api/deleteDesign/${clientId}/${designId}`,
          {
            params: { state: 'AssignedRooms' } // ✅ dynamic room type if needed
          }
        );
        console.log("Deleted:", response.data.message);

        Swal.fire({
          title: 'Deleted!',
          text: response.data.message || 'Design has been deleted.',
          icon: 'success',
        });

        dispatch(fetchAllAssignedRooms(dataOfClient.id));
      } catch (error) {
        console.error("Delete error:", error);

        Swal.fire({
          title: 'Error!',
          text: error.response?.data?.message || 'Something went wrong while deleting.',
          icon: 'error',
        });
      }
    }
  };



const assignToDataDeepCopy = structuredClone(
  data.quotes.filter(item => item.quotiationAssignedStatus === true)
);

  console.log('assignToDataDeepCopy', assignToDataDeepCopy);


  // const [selectedRoom, setSelectedRoom] = useState(null); // Use an array instead of an object
  const [assignedQuotiation, setAssignedQuotiation] = useState(null); // Use an array instead of an object
  const [description, setDescription] = useState('');
  // console.log("selectedRoom", selectedRoom);
  console.log("assignedQuotiation", assignedQuotiation);

  const handleChange = (value) => {
    console.log("selectedRoom", value);
    setAssignedQuotiation(value);
  };


  //assigned project to 

  const handleAssignProject = async () => {
    const assigneeToId = selectedName.userID;  // selected user id 
    // const AssignedProjectID = dataOfClient.id;
    const assignedQuotiation1 = assignedQuotiation;
    const assignedProjectData = {
      quoteID: assignedQuotiation1.ID,
      description: description,
      assignedTime: new Date().toISOString(),
      quotationDate: assignedQuotiation1.quotationDate,
      quotationDiscount: assignedQuotiation1.quotationDiscount,
      quotationName: assignedQuotiation1.quotationName,
      quotationPrice: assignedQuotiation1.quotationPrice,
      quotationTaxation: assignedQuotiation1.quotationTaxation,
      quotationWood: assignedQuotiation1.quotationWood
    }

    try {
      const response = await fetch(`https://us-central1-fabdiz-quote.cloudfunctions.net/api/addClientCompletionDetails/${dataOfClient.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          assigneeToId,
          assignedStatus: 'false',
          assignedProjectData,
          selectedRoom: assignedQuotiation.quotationData
        })
      });

      const data = await response.json();
      if (response.ok) {
        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: data.message || 'Client assigned successfully',
          confirmButtonColor: '#3085d6',
          timer: 2000,
          showConfirmButton: false
        });
        dispatch(fetchProjectList({ userUID, page: currentPage, lim }));
        setOpen(false);
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: data.message || 'An error occurred',
          confirmButtonColor: '#d33'
        });
      }
    } catch (err) {
      Swal.fire({
        icon: 'error',
        title: 'Request Failed',
        text: 'Failed to update client status',
        confirmButtonColor: '#d33'
      });
    }
  };


  const [open, setOpen] = React.useState(false);
  // console.log("OPEN", open);

  const handleClickOpen = () => {
    setOpen(true);
    fetchUsers()
  };

  const handleClose = () => {
    setOpen(false);
  };


  const priceState = useSelector((state) => state.price.value);
  // console.log("priceState", priceState);
  const [newPrice, setNewPrice] = useState(dataOfClient.priceType); // State to manage price type
  const [openDoor, setOpenDoor] = useState(false);

  // console.log("SelectedPrice", SelectedPrice);
  const [increment, setIncrement] = useState(0);
  // console.log("dataOfClient", dataOfClient);



  // Function to modify data before copying

  const { kitchenThingsData } = useSelector(
    (state) => state.kitchenThings
  );

  const { bedroomThingsData } = useSelector(
    (state) => state.bedroomThings
  );

  const { foyerThingsData } = useSelector(
    (state) => state.foyerThings
  );

  const { livingThingsData } = useSelector(
    (state) => state.livingThings
  );

  const { otherWorkThingsData } = useSelector(
    (state) => state.OtherWorkThings
  );

  const { looseThingsData } = useSelector(
    (state) => state.looseThings
  );
  const { accessoriesThingsData } = useSelector(
    (state) => state.accessories
  );


  const changeThePrice = async () => {
    const pricemode = SelectedPrice;
    const newIncrement = increment;
    const quotations = dataOfClient?.id;
    var DataOfTheClient = dataOfClient;

    if (!quotations) {
      console.error("Error: Client ID (quotations) is undefined.");
      return;
    }

    Swal.fire({
      title: 'Updating Prices...',
      html: 'Please wait while we update the prices.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      const snapshot = await db.collection("client").doc(quotations).collection("Rooms").get();

      const updateDataofClient = {
        ...DataOfTheClient,
        priceType: pricemode,
        increment: newIncrement
      };

      try {
        await db.collection("client").doc(quotations).set(updateDataofClient);
        console.log("Client data updated successfully:", updateDataofClient);
      } catch (error) {
        console.error("Error updating client data:", error.message);
      }

      const promises = snapshot.docs.map(async (doc) => {
        const docData = doc.data();
        const updatedData = modifyPrice(docData, newIncrement, pricemode);

        if (!updatedData || typeof updatedData !== 'object' || Array.isArray(updatedData)) {
          console.error("Invalid data format for Firestore update:", updatedData);
          return;
        }

        await db.collection("client").doc(quotations).collection("Rooms").doc(doc.id).update(updatedData);
        console.log("Updated document:", doc.id, updatedData);
      });

      await Promise.all(promises);

      // ✅✅✅ PASTE HERE - After all updates done
      const clientRef = db.collection("client").doc(quotations);
      const freshClientSnapshot = await clientRef.get();
      const freshClientData = freshClientSnapshot.data();
      setDataOfClient(freshClientData);

      Swal.fire({
        icon: 'success',
        title: 'Prices Updated!',
        text: 'All rooms have been updated successfully.',
        timer: 2000,
        showConfirmButton: false,
      });

    } catch (error) {
      console.error("Error updating price:", error.message);
      Swal.close();
    }

    setSelectedPrice(SelectedPrice);
    setOpenDoor(false);
    window.location.reload()
  };


  // ✅ FIXED modifyPrice FUNCTION
  const modifyPrice = (oldData, newIncrement, pricemode) => {
    // console.log("oldData", oldData);

    if (!oldData || typeof oldData !== 'object') {
      console.warn("modifyPrice received invalid data:", oldData);
      return {};
    }

    const incrementPercentage = newIncrement / 100;
    let grandTotalPrice = 0;

    // Deep copy room datasets
    const kitchendata = JSON.parse(JSON.stringify(kitchenThingsData));
    const bedroomdata = JSON.parse(JSON.stringify(bedroomThingsData || []));
    const foyerdata = JSON.parse(JSON.stringify(foyerThingsData || []));
    const livingdata = JSON.parse(JSON.stringify(livingThingsData || []));
    const otherWorkdata = JSON.parse(JSON.stringify(otherWorkThingsData || []));
    const accessoriesdata = JSON.parse(JSON.stringify(accessoriesThingsData || []));


    const findMaterialValue = (roomType, itemName, itemLabel, defaultValue) => {

      // Deep copy room datasets
      const roomDatasets = {
        Kitchen: kitchendata,
        Bedroom: bedroomdata,
        Foyer: foyerdata,
        "Living Room": livingdata,
        "Other Works": otherWorkdata,
        Accessories: accessoriesdata
      }[roomType];
      const matchedItem = roomDatasets.find(match => match.name == itemName);

      if (!matchedItem) {
        console.warn("Material not found:", itemName);
        return defaultValue;
      }

      const selectedMaterial = matchedItem.material?.find(labelObject => labelObject.label === itemLabel);
      return selectedMaterial?.[pricemode] ?? defaultValue;
    };

    let totalPrice = 0;

    if (Array.isArray(oldData.title)) {
      oldData.title = oldData.title.map(item => {
        const value22 = findMaterialValue(oldData.roomType, item.name, item.label, item.value) || 0;

        let price = 0;
        let multiplier = item.type === 'woodwork' ? 1 + incrementPercentage : 1;

        if (item.area > 0) {
          price = value22 * item.area;
        } else if (item.value2 > 0) {
          price = value22 * item.width * item.height * item.qnty;
          if (item.value2 > 0) {
            price += parseFloat(item.value2);
            item.valueIncresed2 = Math.round(item.value2 * multiplier);
          }
        } else if (item.width === 0 && item.height === 0 && item.qnty > 0) {
          price = value22 * item.qnty;
        } else if (item.width > 0 && item.height > 0) {
          price = value22 * item.height * item.width;
        } else if (item.rft > 0) {
          price = value22 * item.rft;
        } else if (item.qnty > 0) {
          price = value22 * item.qnty;
        }
        if (item.painting > 0) {
          price = value22 * item.painting;
        }

        return {
          ...item,
          value: value22,
          valueIncreased: Math.round(value22 * multiplier),
          price: Math.round(price * multiplier)
        };
      });

      totalPrice = oldData.title.reduce((sum, item) => sum + (item.price || 0), 0);
    }

    return {
      ...oldData,
      roomTypePrice: totalPrice,
      priceMode: pricemode
    };
  };


  // const changeThePrice = (state) => {
  //   // Extract fields and titles
  //   const fieldPrice = viewData.map((v) => v.fields || []);
  //   const titlesPrice = viewData.map((v) => v.title || []);
  //   const titlesPrice2 = viewData

  //   // Flatten fieldPrice for easier processing
  //   const mainPriceList = fieldPrice.flat(Infinity);
  //   const PriceList = titlesPrice.flat(Infinity);

  //   console.log("  sathish :", titlesPrice2);
  //   console.log("  sathish :", titlesPrice);
  //   console.log("  sathish :", mainPriceList);
  //   console.log("sathish :", PriceList);

  //   // Update titlesPrice based on state
  //   const updatedPrices = PriceList.map((title) => {
  //     // Find the matching room in mainPriceList by name
  //     const matchedRoom = mainPriceList.find(
  //       (room) => room.name === title.name
  //     );

  //     if (matchedRoom && matchedRoom.material) {
  //       // Find the material with a matching label
  //       const matchedMaterial = matchedRoom.material.find(
  //         (material) => material.label === title.label
  //       );

  //       if (matchedMaterial) {
  //         // Update value based on state
  //         const updatedValue =
  //           state === "value"
  //             ? matchedMaterial.value
  //             : matchedMaterial.oldvalue;

  //         return {
  //           ...title,
  //           price: updatedValue || title.price, // Default to existing value if no match
  //           value: updatedValue || title.value, // Default to existing value if no match
  //         };
  //       }
  //     }
  //     return title;
  //   });

  //   // Update state
  //   setPriceState(state); // Set the price state
  //   setUpdatedTitlesPrice(updatedPrices); // Store updated titlesPrice

  //   console.log("Updated Titles Price:", updatedPrices);
  // };

  ///////////////////////////////////////////////////////////////////////////////

  const [datac, setDatac] = useState(result);
  const [activeIndex, setActiveIndex] = useState(0);

  console.log("activeIndex", activeIndex);
  console.log("result", result);
  console.log("datac", datac);


  const handleDragEnd = (resultg) => {
    const { source, destination } = resultg;
    const clientId = dataOfClient.id;

    if (!destination || source.index === destination.index) return;

    const reordered = Array.from(datac);
    const [moved] = reordered.splice(source.index, 1);
    reordered.splice(destination.index, 0, moved);

    console.log("reordered", reordered);
    setDatac(reordered);

    // const reorderedWithOrder = reordered.map((room, index) => ({
    //   id: room.id,
    //   // order: index,
    // }));

    // console.log("Reordered Rooms:", reorderedWithOrder);

    // fetch('https://us-central1-fabdiz-quote.cloudfunctions.net/api/updateRoomOrder', {
    //   method: 'PATCH', 
    //   headers: {
    //     'Content-Type': 'application/json',
    //   },
    //   body: JSON.stringify({
    //     projectId: clientId,
    //     reorderedRooms: reorderedWithOrder,
    //   }),
    // })
    //   .then(response => response.json())
    //   .then(() => {
    //     console.log("✅ Room order updated successfully");


    // dispatch(fetchRoomList({ Id: clientId }));
    // })
    // .catch((error) => {
    //   console.error("❌ Failed to update room order:", error);
    // });
  };
  const [selectedOptions, setSelectedOptions] = useState({});
  const loading = useSelector((state) => state.quotationPermission.loading);
  const [selectedOptionLoader, setSelectedOptionLoader] = useState({})
  console.log("mainData", selectedOptions);

  const handleCheckboxChange = async (rowId, key, value) => {
    setSelectedOptionLoader((prev) => ({ ...prev, [rowId]: true }));
    const toggledValue = !value;

    // 1. Prepare updated values
    const updatedRowPermissions = {
      ...(selectedOptions[rowId] || {}),
      [key]: toggledValue,
    };

    // 2. Update local state
    setSelectedOptions((prev) => ({
      ...prev,
      [rowId]: updatedRowPermissions,
    }));

    // 3. Update main data
    const permissionData1 = data.quotes.map((quote) => {
      if (quote.ID === rowId) {
        return {
          ...quote,
          quotationpermission: {
            ...quote.quotationpermission,
            ...updatedRowPermissions, // ✅ inject all key-value pairs
          },
        };
      }
      return quote;
    });

    const permissionData = permissionData1.find((quote) => quote.ID === rowId);

    console.log("mainData", permissionData);

    try {
      // ✅ Wait for the async thunk to complete
      await dispatch(updateQuotationPermission(permissionData)).unwrap();
    } catch (err) {
      console.error("Update failed", err);
    } finally {
      // ✅ Now hide the loader
      setSelectedOptionLoader((prev) => ({ ...prev, [rowId]: false }));
    }
  };

  return (
    <Container fluid>
      <Row className='m-0'>
        <Col sm={1} >

          <Modal show={openDoor} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header onClick={() => setOpenDoor(false)} closeButton>
              <Modal.Title id="contained-modal-title-vcenter">Price Type</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form onSubmit={(e) => {
                e.preventDefault();  // Prevent default form submission
                changeThePrice();    // Call the function
              }}>
                <div className="container">
                  <p>Price Change To</p>
                  <select
                    aria-label="Room Type Select"
                    value={SelectedPrice}
                    onChange={(e) => setSelectedPrice(e.currentTarget.value)}
                  >
                    <option value=""></option>
                    <option value="oldvalue">Old Price</option>
                    <option value="value">New Price</option>
                  </select>
                </div>
                <div className="container">
                  <p>Increment</p>
                  <input
                    type="number"
                    placeholder="Increment"
                    value={increment}
                    onChange={(e) => setIncrement(e.target.value)}
                  />
                </div>
                <Modal.Footer>
                  <Button type="submit">Change</Button>
                  <Button onClick={() => setOpenDoor(false)}>Close</Button>
                </Modal.Footer>
              </form>
            </Modal.Body>
          </Modal>

          <Tab.Container  >
            <Row>
            </Row>
          </Tab.Container>
        </Col>
        <Col sm={11}>
          <Row >
            <Col>
              <Col sm={10}  >


              </Col>
              <Col  >
              </Col>

              <Col
                sm={2}
              >



              </Col>


            </Col>
          </Row>
          <Row className="p-4">
            <Row>
              <hr />
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignContent: 'center'
              }}>
                <Breadcrumb >
                  {/* First item: Projects */}
                  <Breadcrumb.Item

                    className="breadcrumb-item-animate"
                    style={{
                      fontSize: "13px",
                      fontWeight: "bold",
                      padding: 10,
                      color: "#333",
                      textTransform: "uppercase",
                      letterSpacing: "-0.5px",
                      transition: "all 0.3s ease", // Smooth transition for all properties
                      marginLeft: "20px", // Space between elements
                      textDecoration: "none",
                      backgroundColor: '#ea6e2b',
                      borderRadius: "0 20px 20px 0", // Rounded left, sharp right
                      height: 30,
                      width: 'auto',
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer", // Pointer on hover
                      transition: "transform 0.3s ease, background-color 0.3s ease", // Animate transform and background color
                      marginLeft: "10px",

                      // Hover effect
                      ":hover": {
                        backgroundColor: "#FFA500", // Change background color on hover
                        transform: "scale(1.1)", // Slightly increase the size on hover
                        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)", // Enhance shadow on hover
                      }
                    }}
                    href="/assigned"
                  >
                    Assigned Projects
                  </Breadcrumb.Item>

                  {/* Second item: dataOfClient.pname */}
                  <Breadcrumb.Item

                    style={{
                      height: 30,
                      width: 'auto',
                      fontSize: "13px",
                      fontWeight: "bold",
                      color: "white",
                      textTransform: "uppercase",
                      borderRadius: "0 20px 20px 0",
                      backgroundColor: '#ea6e2b',
                      marginLeft: "10px",
                      padding: '0 5px 0 5px',
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",

                    }}

                    active
                  >
                    {dataOfClient.cname}
                  </Breadcrumb.Item>

                </Breadcrumb>
                {/* <Button style={{ backgroundColor: 'green', marginBottom: '16px' }} onClick={handleClickOpen} >Assign To</Button> */}
              </div>
              <hr />

            </Row>

            {viewLoader ? <center>
              <Triangle
                height="120"
                color="#ff5100"
                ariaLabel="triangle-loading"
                radius="1"
                wrapperStyle={{ position: "absolute", top: "50%", left: "50%", }}
                wrapperClass=""
                visible={true}
              /> </center> : viewData ?
              <Row>

                <Col >
                  <Row>

                    <Col style={{
                      display: 'flex',
                      justifyContent: "space-between",
                      alignItems: "center",
                      margin: 15,
                    }}>

                      <h2 style={{ fontSize: 18, fontFamily: 'Arial', fontWeight: 100, textTransform: "uppercase", color: '#e85d13' }}>{dataOfClient.cname} ROOMS </h2>

                      {/* {userdata.priceType === "oldvalue" ? (
                        <Button
                          className="w-40 bg-primary"
                          onClick={() => setOpenDoor(true)}
                        >
                          Quotation is in OLD PRICE
                        </Button>
                      ) : (
                        <Button
                          className="w-40 bg-warning"
                          onClick={() => setOpenDoor(true)}
                        >
                          Quotation is in NEW PRICE
                        </Button>
                      )} */}


                      {dataOfClient.from !== 'sent' && <button className="buttonDesign" onClick={() => addRoom()}>Add room</button>}
                    </Col>

                  </Row>
                  <Row className="navigation" style={{
                    marginBottom: '50px',
                    padding: '20px',
                    borderRadius: '15px',
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                    backgroundColor: '#ffffff', // Light background color

                  }}>
                    <Col style={{ minHeight: 400 }}>
                      <Tab.Container
                        id="left-tabs-example"
                        defaultActiveKey="0"
                        variant="pills"
                        justify
                      >
                        <Col sm={12}  >
                          <DragDropContext onDragEnd={handleDragEnd}>
                            <div
                              style={{
                                display: 'flex',
                                gap: 39,
                                padding: '20px',
                                flexWrap: 'wrap',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                background: '#f8f9fa',
                                borderRadius: '5px',
                                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                                // border: ' 1px solid rgb(207, 207, 207)',
                              }}
                            >
                              <Droppable droppableId="ROOT" direction="horizontal" type="group">
                                {(provided) => (
                                  <div
                                    className="store-card"
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                    style={{ display: 'flex', flexWrap: 'wrap', gap: '40px' }}
                                  >
                                    {result.length > 0 ? (
                                      result.map((i, ind) => (
                                        <Draggable draggableId={i.id || i.ID} index={ind} key={i.id || i.ID}>
                                          {(provided) => (
                                            <Nav.Item
                                              ref={provided.innerRef}
                                              {...provided.draggableProps}
                                              {...provided.dragHandleProps}
                                            >
                                              <Nav.Link eventKey={ind} onClick={() => setActiveIndex(ind)}>
                                                <Row className={`yytt ${activeIndex === ind ? 'active' : ''}`}>
                                                  <Col md={9}>{i.roomTypeName}</Col>
                                                  <Col md={3}>
                                                    {dataOfClient.from !== 'sent' && <Dropdown style={{ display: 'flex' }}>
                                                      <Dropdown.Toggle
                                                        split
                                                        as={CustomToggle}
                                                        variant="light"
                                                        id="dropdown-split-basic"
                                                      >
                                                        <i className="bi bi-three-dots-vertical"></i>
                                                      </Dropdown.Toggle>
                                                      <Dropdown.Menu >
                                                        <Dropdown.Item className="editItem" onClick={() => renameModal(i)}>Rename Room</Dropdown.Item>
                                                        <Dropdown.Item className="editItem" onClick={() => addDesign(i)}>Add Design Option</Dropdown.Item>
                                                        <Dropdown.Item className="editItem" onClick={() => deleteRoomModal(i)}>Delete Room</Dropdown.Item>
                                                      </Dropdown.Menu>
                                                    </Dropdown>}
                                                  </Col>
                                                </Row>
                                              </Nav.Link>
                                            </Nav.Item>
                                          )}
                                        </Draggable>
                                      ))
                                    ) : (
                                      <p className="allert">No rooms available</p>
                                    )}
                                    {provided.placeholder}
                                  </div>
                                )}
                              </Droppable>
                            </div>
                          </DragDropContext>



                        </Col>
                        <Col sm={12} style={{ backgroundColor: '#e2e2e2' }} className="Design">

                          <Tab.Content className="DesignItems" >

                            {result.map((i, ind) => (
                              <Tab.Pane eventKey={ind}>
                                <Row style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  marginTop: 20,
                                  marginBottom: 20,


                                }}>
                                  <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }} ><h6>Design options for </h6><h5 style={{ color: '#e85d13' }}>{i.roomType}</h5></span>

                                  {dataOfClient.from !== 'sent' && <button className="buttonDesign" style={{
                                    width: '30vh',
                                    position: 'absolute',
                                    right: 100,
                                  }} onClick={() => addDesign(i)}>Add design options</button>}


                                </Row>
                                {viewData.assignedRooms.length > 0 && (
                                  <Row>
                                    {viewData.assignedRooms.map((l, index) =>
                                      l.roomTypeName === i.roomTypeName ? (
                                        <Col
                                          key={index}
                                          xs={12}
                                          sm={6}
                                          md={4}
                                          lg={3}
                                          style={{
                                            marginBottom: '2rem', // Space between rows
                                          }}
                                        >
                                          <div
                                            style={{
                                              width: 'auto',
                                              minHeight: '1vw',
                                              backgroundColor: (l.roomType === "ExtraItems" || l.roomType === "Other Works")
                                                ? null
                                                : dataOfClient.priceType === 'value'
                                                  ? 'yellow'
                                                  : 'green',
                                              borderRadius: 8,
                                              boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                                              display: 'flex',
                                              flexDirection: 'column',
                                              alignItems: 'center',
                                              justifyContent: 'center',
                                              padding: '0.2rem',
                                            }}
                                          >
                                            <h7 style={{ fontSize: '13px', color: 'balck' }} >{l.roomType === "ExtraItems" ? null : dataOfClient.priceType === 'value' ? 'New price' : 'Old price'}</h7>

                                            <Card
                                              style={{
                                                width: '100%',
                                                boxShadow: 'rgba(0, 0, 0, 0.2) 0px 8px 24px',
                                                position: 'relative',
                                                marginTop: '1rem',
                                              }}
                                              bg="light"
                                            >
                                              <Card.Body
                                                className="hover-text"
                                                style={{
                                                  boxShadow:
                                                    'rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset',
                                                }}
                                              >
                                                <Card.Title>
                                                  <Row>
                                                    <Col md={10}>
                                                      <h7 style={{ fontSize: '1rem' }}> {l.roomTypeDesign}</h7>
                                                    </Col>
                                                    <Col md={2}>
                                                      <Dropdown className="w-100">
                                                        <Dropdown.Toggle as={CustomToggle} variant="light">
                                                          <i className="bi bi-three-dots-vertical"></i>
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu
                                                          style={{
                                                            position: 'absolute',
                                                            zIndex: 1050,
                                                            marginTop: '5px',
                                                          }}
                                                        >
                                                          {dataOfClient.from !== 'sent' && <Dropdown.Item className="editItem" onClick={() => renameDesignModalFun(l)}>Rename</Dropdown.Item>}
                                                          {dataOfClient.from !== 'sent' && <Dropdown.Item className="editItem" onClick={() => deleteDocument(l)}>Delete</Dropdown.Item>}
                                                          {dataOfClient.from !== 'sent' && <Dropdown.Item className="editItem" onClick={() => duplicationDesign(l)}>Duplicate</Dropdown.Item>}
                                                          <Dropdown.Item className="editItem" onClick={() => viewDesign(l)}>View</Dropdown.Item>
                                                          {dataOfClient.from !== 'sent' && <Dropdown.Item className="editItem" onClick={() => editDesign(l)}>Edit</Dropdown.Item>}
                                                        </Dropdown.Menu>
                                                      </Dropdown>
                                                    </Col>
                                                  </Row>
                                                </Card.Title>
                                                <Card.Subtitle className="mb-2 text-muted">
                                                  {'\u20B9'} {l.roomTypePrice}
                                                </Card.Subtitle>
                                              </Card.Body>
                                            </Card>
                                          </div>
                                        </Col>
                                      ) : null
                                    )}
                                  </Row>
                                )}




                              </Tab.Pane>
                            ))}

                          </Tab.Content>

                        </Col>
                      </Tab.Container>

                    </Col>
                  </Row>
                  <Row style={{
                    marginBottom: '10px',
                    padding: '20px',
                    borderRadius: '15px',
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow
                    backgroundColor: '#ffffff', // Light background color
                  }}>
                    <Col className="md-8">
                      <h2 style={{ fontSize: 24, fontFamily: 'Arial', fontWeight: 100, color: '#e85d13' }}>Quotations</h2>

                    </Col>
                    <Col className="md-4 d-flex flex-row-reverse">
                      {dataOfClient.from !== 'sent' && <Button className="buttonDesign" style={{ width: '16vw' }} onClick={() => navigation('/assigned/view-rooms/add-quotation', { state: dataOfClient })}>Add Quotations</Button>}

                    </Col>
                  </Row>
                  <Row className="mt-1">
                    <Col>
                      <div className="table-container">
                        <div className="tableScroll">
                          <table responsive hover  >
                            <thead>
                              <tr className="table-warning">

                                <th></th>
                                <th>Quote ID</th>
                                <th>Name</th>
                                <th>Create</th>
                                <th>Status</th>
                                <th>Total (Rs.)</th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>

                              </tr>
                            </thead>
                            <tbody className="table-light">
                              {data && data.quotes ? data.quotes.map((e, i) => (
                                <tr key={i}>

                                  <td>{i + 1}</td>
                                  <td>{e.ID}</td>
                                  <td>{e.quotationName || 'null'}</td>
                                  <td>
                                    {e.quotationDate}
                                  </td>
                                  <td><p style={{ backgroundColor: '#4caf50', borderRadius: 15, textAlign: 'center', color: '#FFFFFF', fontSize: 15 }}>Submitted</p></td>
                                  <td>
                                    {'\u20B9'} {e.quotationPrice}
                                  </td>
                                  <td>
                                    {/* <Button variant="primary" >D/L Xlsx</Button> */}
                                    {/* <ExportToExcel e={e}/> */}
                                    <ViewProfile e={e} />
                                    {/* <ExportExcel /> */}
                                  </td>
                                  <td>
                                    {/* <Button variant="primary" onClick={()=>{navigation('/projects/view-rooms')}}>Download</Button> */}
                                    {/* <Suspense fallback={<button className="btn btn-primary">Loading...</button>}>
    <LazyPDFDownloadButton e={e} />
  </Suspense> */}
                                    {/* <PDFDownloadLink
                    document={<ClientPDF e={e}/>}
                    fileName={fileName}
                   className="btn btn-primary">
                    {({ blob, url, loading, error }) =>
                      loading ? "Loading..." : "D/L PDF"
                    }
                 </PDFDownloadLink> */}
                                    {/* <PDFViewer width={800} height={500} showToolbar={false}>
        <ClientPDF e={e} />
      </PDFViewer> */}
                                  </td>
                                  <td style={{ padding: "10px" }}>
                                    <Link to="/QC-ClientPDFview" state={{ e }}>
                                      <button
                                        style={{
                                          backgroundColor: "#1976d2",
                                          border: "none",
                                          color: "#fff",
                                          padding: "6px 14px",
                                          borderRadius: "6px",
                                          cursor: "pointer",
                                        }}
                                      >
                                        QC-Quote
                                      </button>
                                    </Link>
                                  </td>
                                  <td>
                                    {/* <Button variant="primary" onClick={()=>{navigation('/client-quotation')}}>Download</Button> */}
                                    {/* <a href={`/client-quotation/${e.ID}`}  target="_blank"><Button>Open / Share</Button></a>  */}
                                    <a href={`/project/${e.clientDetails.id}/quotations/${e.ID}`} target="_blank"><button className='buttonDesign'>Open / Share</button></a>
                                  </td>
                                  <td>
                                    {dataOfClient.from !== 'sent' && <Dropdown>
                                      <Dropdown.Toggle variant="secondary">
                                        Select Options
                                      </Dropdown.Toggle>

                                      <Dropdown.Menu style={{ padding: '10px' }}>
                                        {selectedOptionLoader[e.ID] ? (
                                          <div style={{ padding: '10px', textAlign: 'center' }}>
                                            <Spinner animation="border" size="sm" variant="primary" />
                                          </div>
                                        ) : (
                                          Object.entries(e.quotationpermission || {}).map(([key, value]) => (
                                            <Form.Check
                                              key={key}
                                              type="checkbox"
                                              id={`checkbox-${i}-${key}`}
                                              label={`${key} (${selectedOptions[e.ID]?.[key] ?? value ? 'true' : 'false'})`}
                                              checked={selectedOptions[e.ID]?.[key] ?? value}
                                              onChange={() =>
                                                !selectedOptionLoader[e.ID] &&
                                                handleCheckboxChange(e.ID, key, selectedOptions[e.ID]?.[key] ?? value)
                                              }
                                            />
                                          ))
                                        )}
                                      </Dropdown.Menu>
                                    </Dropdown>}
                                  </td>


                                </tr>
                              )) : null}



                            </tbody>






                          </table>
                        </div>
                      </div>









                      {/* Pagination controls */}
                      {/* <Row className="mt-3">
                        <Col style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          marginTop: '20px',
                        }}>
                          <Button onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1}>
                            Previous
                          </Button>
                          <span className="mx-2">Page {currentPage}</span>
                          <Button onClick={() => setCurrentPage(prev => prev + 1)} disabled={!data.hasNextPage}>
                            Next
                          </Button>
                        </Col>
                      </Row> */}

                    </Col>
                  </Row>
                </Col>
              </Row> :
              <Row className="addRow" >
                <Col className="ggff">
                  {/* <img src={require("../assests/add.png")}  alt='Dashboard' style={{ width: '50%',height:'50%', resize:'cover' }} /> */}
                  <p style={{ fontSize: 36, fontFamily: 'Arial', fontWeight: 100 }}>You don’t have any rooms yet</p>
                  <Button className="w-25" onClick={() => navigation('/projects/view-rooms/add-rooms', { state: dataOfClient })}>Add room</Button>
                </Col>

              </Row>}


            <Modal show={renameOn} onHide={handleRenameCloseOn}>
              <Modal.Body>
                {/* <Modal.Title style={{ fontSize: 15, fontWeight: "bold" }}>
                Do you Rename?
              </Modal.Title> */}
                <Form>
                  <Form.Control
                    type="text"
                    value={nameRoomTypeName}
                    onChange={(e) => { setNameRoomTypeName(e.target.value) }}
                    autoFocus
                  />

                </Form>
              </Modal.Body>
              <Modal.Footer>
                <button className='buttonDesign-Danger' onClick={() => handleRenameCloseOn()}>
                  Cancel
                </button>
                <button className='buttonDesign-Safe' onClick={() => handleRenameCom()}>Rename Room</button>
              </Modal.Footer>
            </Modal>
            <Modal show={renameDesignModal} onHide={handleRenameDesignCloseModal}>
              <Modal.Body>
                {/* <Modal.Title style={{ fontSize: 15, fontWeight: "bold" }}>
                Do you Rename?
              </Modal.Title> */}
                <Form>
                  <Form.Control
                    type="text"
                    value={newDesignTypeName}
                    onChange={(e) => { setNewDesignTypeName(e.target.value) }}
                    autoFocus
                  />

                </Form>
              </Modal.Body>
              <Modal.Footer>
                <button className='buttonDesign-Danger' onClick={() => handleRenameDesignCloseModal()}>
                  Cancel
                </button>
                <button className='buttonDesign-Safe' onClick={() => handleRenameDesignModal()}>Rename</button>
              </Modal.Footer>
            </Modal>


            <React.Fragment >
              <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="draggable-dialog-title"
                fullWidth
                maxWidth="md"
              >


                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                  Assign User
                </DialogTitle>
                <DialogContent>
                  <DialogContentText>Select a user to assign</DialogContentText>
                  <Autocomplete
                    disablePortal
                    options={userList}
                    getOptionLabel={(option) => option.label}
                    sx={{ width: 300, marginTop: 5 }}
                    value={selectedName}
                    onChange={(event, newValue) => setSelectedName(newValue)}
                    renderInput={(params) => <TextField {...params} label="Users" />}
                  />
                  <hr />
                  <DialogContentText>
                    Add Quotiation
                  </DialogContentText>
                  <div>

                  </div>
                  {assignToDataDeepCopy.map((e, i) => (
                    <div className="table-container">
                      <div className="tableScroll">
                        <table>
                          <thead>
                            <tr >
                              <th></th>
                              <th>Quote ID</th>
                              <th>Name</th>
                              <th>Create</th>
                              <th>Status</th>
                              <th>Total (Rs.)</th>

                            </tr>
                          </thead>
                          <tbody >

                            <tr key={i}>
                              <td>
                                <input
                                  type="radio"
                                  name="roomSelection"
                                  onChange={() => handleChange(e)}
                                  style={{ width: '20px', height: '20px' }}
                                />
                              </td>

                              <td>{i + 1}</td>
                              {/* <td>{e.ID}</td> */}
                              <td>{e.quotationName || 'null'}</td>
                              <td>
                                {e.quotationDate}
                              </td>
                              <td><p style={{ backgroundColor: '#4caf50', borderRadius: 15, textAlign: 'center', color: '#FFFFFF', fontSize: 15 }}>Submitted</p></td>
                              <td>
                                {'\u20B9'} {e.quotationPrice}
                              </td>
                            </tr>

                            {/* {viewData.map((l) => l.roomTypeName == data.roomTypeName ? (
                              <tr>

                                <td>
                                  <input onChange={(e) => handleChange(e, l)} style={{ width: '20px', height: '20px' }} type="checkbox" />
                                </td>
                                <td>
                                  {l.roomTypeDesign}
                                </td>
                                <td></td>
                                <td>{'\u20B9'} {l.roomTypePrice}</td>
                                <td>-</td>
                                <td>{'\u20B9'} {l.roomTypePrice}</td>
                              </tr>) : null)} */}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    // <h6 key={data.id || data.roomTypeName}>
                    //   {data.roomTypeName}
                    // </h6>
                  ))}
                  <TextField
                    fullWidth
                    multiline
                    rows={3}
                    margin="normal"
                    label="Description"
                    placeholder="Enter description here..."
                    variant="outlined"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </DialogContent>
                <DialogActions>

                </DialogActions>
                <DialogActions>
                  <button className='buttonDesign-Danger' autoFocus onClick={handleClose}>Cancel</button>
                  <button className='buttonDesign-Safe' onClick={handleAssignProject}>Assign</button>
                </DialogActions>

              </Dialog>
            </React.Fragment>


          </Row>

        </Col>
      </Row>



    </Container>
  );
}
export default ProjectView;
